export default __webpack_public_path__ + "static/media/file.d922d690.png";